import { render } from "./Tafs.vue?vue&type=template&id=758d6a36&scoped=true"
import script from "./Tafs.vue?vue&type=script&lang=js"
export * from "./Tafs.vue?vue&type=script&lang=js"

import "./Tafs.vue?vue&type=style&index=0&id=758d6a36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-758d6a36"]])

export default __exports__